import { Controller } from "@hotwired/stimulus";

// Drives a Knox modal dialog (a native <dialog>). showModal() supplies the
// scrim, centering, and Escape-to-close for free; we add open/close actions
// and click-outside-to-dismiss.
export default class extends Controller {
  open() {
    this.element.showModal()
  }

  close() {
    this.element.close()
  }

  // A click whose target is the <dialog> itself landed on the backdrop, not
  // the card, so dismiss.
  backdropClose(event) {
    if (event.target === this.element) this.close()
  }
}
